module.exports = __webpack_public_path__ + "static/img/fullscreen-image_time-attendance_600.e67108d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/time-attendance/fullscreen-image_time-attendance_600.png
// module id = Jbny
// module chunks = 0